import type { GameEvent } from "../contracts/game";
import type { ArcadeStateV1, GameStats } from "../platform/storage/schema";

function ensureStats(state: ArcadeStateV1, gameId: string): GameStats {
  const existing = state.games[gameId];
  if (existing) return existing;
  const stats: GameStats = {
    launches: 0,
    matchesStarted: 0,
    matchesCompleted: 0,
    totalPlayMs: 0,
    lastPlayedAt: null,
    lastCompletedAt: null,
  };
  state.games[gameId] = stats;
  return stats;
}

function validTimestamp(now: number): number {
  if (!Number.isFinite(now) || now < 0) return 0;
  return Math.round(now);
}

export function recordLaunch(state: ArcadeStateV1, gameId: string): void {
  ensureStats(state, gameId).launches += 1;
}

export function recordGameEvent(
  state: ArcadeStateV1,
  gameId: string,
  event: GameEvent,
  now: number,
): void {
  const stats = ensureStats(state, gameId);
  switch (event.type) {
    case "match-started":
      stats.matchesStarted += 1;
      stats.lastPlayedAt = validTimestamp(now);
      break;
    case "match-completed":
      stats.matchesCompleted += 1;
      stats.lastCompletedAt = validTimestamp(now);
      break;
    default:
      break;
  }
}

export function recordPlayDuration(state: ArcadeStateV1, gameId: string, milliseconds: number): void {
  if (!Number.isFinite(milliseconds) || milliseconds <= 0) return;
  ensureStats(state, gameId).totalPlayMs += Math.round(milliseconds);
}
